export { default } from "./DataPageTable";
